import React from "react";
import AttachmentContent from "./attachment-content.jsx";
import ActivitiesContent from "./activities-content.jsx";
import ScheduleGarrisonUtils from "../utils/schedulegarrison-utils.jsx";

const UpdateContent = ({ element }) => {
    let updateData;

    try {
        updateData = typeof element?.details === "string" ? JSON.parse(element.details) : element?.details ?? {};
    } catch {
        updateData = {};
    }

    const attachments = updateData?.attachment;
    const activities = updateData?.activities;

    const {current: group, previous: previousGroup} = ScheduleGarrisonUtils.splitDiff(updateData.garrison_group);

    const hasContent = ScheduleGarrisonUtils.hasVisibleFields(updateData);
    if (!hasContent) return;

    return (
        <tr className="update-content-table">
            <td colSpan={14}>
                <table className="applied insider w-full">
                    <thead>
                        <tr className="text-left">
                            <th style={{ width: "30%" }}>Campo</th>
                            <th style={{ width: "35%" }}>Novo</th>
                            <th style={{ width: "35%" }}>Antigo</th>
                        </tr>
                    </thead>

                    <tbody>

                        <ScheduleGarrisonUtils.Row
                            isUpdate
                            label="Nome"
                            newValue={ScheduleGarrisonUtils.getNew(updateData.name) ?? updateData.name?.new}
                            oldValue={ScheduleGarrisonUtils.getOld(updateData.name) ?? updateData.name?.old}
                        />

                        <ScheduleGarrisonUtils.Row
                            isUpdate
                            label="Cadastro"
                            newValue={(ScheduleGarrisonUtils.getNew(updateData.created_at) ?? updateData.created_at?.new) ?? (ScheduleGarrisonUtils.getNew(updateData.date_register) ?? updateData.date_register?.new)}
                            oldValue={(ScheduleGarrisonUtils.getOld(updateData.created_at) ?? updateData.created_at?.old) ?? (ScheduleGarrisonUtils.getOld(updateData.date_register) ?? updateData.date_register?.old)}
                        />

                        <ScheduleGarrisonUtils.Row
                            isUpdate
                            label="Período disponível"
                            newValue={ScheduleGarrisonUtils.formatPeriod(
                                ScheduleGarrisonUtils.getNew(updateData.date_usage_min) ?? updateData.date_usage_min?.new,
                                ScheduleGarrisonUtils.getNew(updateData.date_usage_max) ?? updateData.date_usage_max?.new
                            )}
                            oldValue={ScheduleGarrisonUtils.formatPeriod(
                                ScheduleGarrisonUtils.getOld(updateData.date_usage_min) ?? updateData.date_usage_min?.old,
                                ScheduleGarrisonUtils.getOld(updateData.date_usage_max) ?? updateData.date_usage_max?.old
                            )}
                        />

                        <ScheduleGarrisonUtils.Row
                            isUpdate
                            label="Descrição"
                            newValue={ScheduleGarrisonUtils.getNew(updateData.description) ?? updateData.description?.new}
                            oldValue={ScheduleGarrisonUtils.getOld(updateData.description) ?? updateData.description?.old}
                        />

                        <ScheduleGarrisonUtils.Row
                            isUpdate
                            label="Inativar"
                            newValue={ScheduleGarrisonUtils.getNew(updateData.inactive) ?? updateData.inactive?.new}
                            oldValue={ScheduleGarrisonUtils.getOld(updateData.inactive) ?? updateData.inactive?.old}
                        />

                        <ScheduleGarrisonUtils.Row
                            isUpdate
                            label="Motivo da inativação"
                            newValue={ScheduleGarrisonUtils.getNew(updateData.inactive_observation) ?? updateData.inactive_observation?.new}
                            oldValue={ScheduleGarrisonUtils.getOld(updateData.inactive_observation) ?? updateData.inactive_observation?.old}
                        />

                        <ScheduleGarrisonUtils.Row
                            isUpdate
                            label="Dias da semana"
                            newValue={ScheduleGarrisonUtils.formatWeekdays(group.weekdays)}
                            oldValue={ScheduleGarrisonUtils.formatWeekdays(previousGroup.weekdays)}
                        />

                        <ScheduleGarrisonUtils.Row
                            isUpdate
                            label="Equipe"
                            newValue={ScheduleGarrisonUtils.formatArray(group.teams)}
                            oldValue={ScheduleGarrisonUtils.formatArray(previousGroup.teams)}
                        />

                        <ScheduleGarrisonUtils.Row
                            isUpdate
                            label="Função destinada"
                            newValue={ScheduleGarrisonUtils.formatGroupFunctions(group.intendedFunctions)}
                            oldValue={ScheduleGarrisonUtils.formatGroupFunctions(previousGroup.intendedFunctions)}
                        />

                        <ScheduleGarrisonUtils.Row
                            isUpdate
                            label="Setor"
                            newValue={ScheduleGarrisonUtils.formatArray(group.sectors)}
                            oldValue={ScheduleGarrisonUtils.formatArray(previousGroup.sectors)}
                        />

                        <ScheduleGarrisonUtils.Row
                            isUpdate
                            label="Atribuir automaticamente às guarnições"
                            newValue={ScheduleGarrisonUtils.getNew(updateData.auto_apply_by_group) ?? updateData.auto_apply_by_group?.new}
                            oldValue={ScheduleGarrisonUtils.getOld(updateData.auto_apply_by_group) ?? updateData.auto_apply_by_group?.old}
                        />

                        { activities && (
                            <ActivitiesContent
                                activities={activities}
                                isUpdate
                            />
                        )}

                        { attachments && (
                            <AttachmentContent
                                attachments={Array.isArray(attachments) ? attachments : Object.values(attachments)}
                                isUpdate
                            />
                        )}

                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default UpdateContent;